<template>
	<div>
		<div class="list-btn">
			<Button type="primary" @click="add">新增</Button>
		</div>
		<Table border :columns="columns12" :data="data6"  :loading="loading">
			<template slot-scope="{ row }" slot="name">
				<strong>{{ row.name }}</strong>
			</template>
			<template slot-scope="{ row, index }" slot="action">
				<Button type="primary" size="small" style="margin-right: 5px" @click="update(row.id)">修改</Button>
				<!-- <Button @click="modal2 = true" size="small" style="margin-right: 5px" class="delete">删除</Button> -->
				<Modal v-model="modal2" width="360">
					<p slot="header" style="color:#f60;text-align:center">
						<Icon type="ios-information-circle"></Icon>
						<span>删除数据</span>
					</p>
					<div style="text-align:center">
						<p>确定删除？</p>
					</div>
					<div slot="footer">
						<Button type="error" size="large" long :loading="modal_loading" @click="remove(row.id)">删除</Button>
					</div>
				</Modal>
			</template>
		</Table>
		<div class="my-page">
			<page :total="total" @updatePage="updatePage" @updateSize="updateSize"></page>
		</div>
	</div>
</template>
<script>
	import http from '@/http/http.js'
	import page from '@/components/comm/page.vue'
	export default {
		data() {
			return {
				modal2: false,
				modal_loading: false,
				query: {//查询参数
					page: 0,
					size: 10
				},
				loading: false,
				total: 0,
				deleteId:'',//修改状态的id
				columns12: [{
						title: 'id',
						key: 'id'
					},
					{
						title: '名称',
						key: 'name'
					},
					{
						title: '录入时间',
						key: 'createdTime'
					},
					{
						title: '操作',
						slot: 'action',
						width: 150,
						align: 'center'
					}
				],
				data6: [
				],

			}
		},
		methods: {
			update(id) { //修改
				this.$router.push({
					name: 'jm/mac/faultType/update',
					query:{id:id}
				})
			},
			remove(id) { //删除
				setTimeout(() => {
					this.modal_loading = false;
					this.modal2 = false;
					this.$Message.success('删除成功！！！');
				}, 1000)
			},
			add() {
				this.$router.push({
					name: 'jm/mac/faultType/add'
				})
			},
			updatePage(page) { //页码改变的回调，返回改变后的页码
				this.query.page = page - 1
				this.ajaxPage()
			},
			updateSize(size) { //切换每页条数时的回调，返回切换后的每页条数
				this.query.size = size
				this.ajaxPage()
			},
			ajaxPage() {
				this.loading = true
				let _this=this
				http.http({
				    //这里是你自己的请求方式、url和data参数
				    method: 'post',
				    url: http.url + '/fac/fault/type/page',
				    data: _this.query,
					_this: _this,
					success: function(data) {
						_this.total = data.macFaultTypes.totalElements
						_this.data6 = data.macFaultTypes.content
						_this.loading = false
					}
				    //假设后台需要的是表单数据这里你就可以更改
				  })
				
			}
			
		},
	    components: {
	    	page
	    },
		created(){
			this.ajaxPage()
		}
	}
</script>
<style scoped="scoped">
	.list-btn {
		margin-bottom: 20px;
	}

	.delete {
		/* background-color: red;
		color: #333333; */
	}
	.my-page{
		display: flex;
		justify-content: flex-end;
		margin-top: 20px;
	}
</style>



// WEBPACK FOOTER //
// src/components/jm/pcoduction/macFaultType/list.vue